// Change of url addresses for server interfaces depending on the local or web version

//let url = 'http://localhost'
let url = 'https://ollo.link'


export default url

